import { genderType } from "redux/commonTypes";
import { galleryTypes } from "../photos/photosTypes";

export const actionTypes = {
  SEARCH_USERS_IDS: "USERS:SEARCH_IDS",
  SET_USERS_IDS: "USERS:SET_IDS",
  APPEND_USERS_IDS: "USERS:APPEND_IDS",
  SET_LOADING_MORE_IDS: "USERS:SET_LOADING_MORE_IDS",
  SET_USERS_PAGE: "USERS:SET_PAGE",
  GET_USERS_PREVIEWS: "USERS:GET_PREVIEWS",
  SET_USERS_PREVIEWS: "USERS:SET_PREVIEWS",
  SET_USERS_PREVIEWS_BY_PAGE: "USERS:SET_PREVIEWS_BY_PAGE",
  GET_FILTER: "USERS:GET_FILTER",
  GET_FILTER_SELECTS: "USERS:GET_SELECTS",
  SET_FILTER: "USERS:SET_FILTER",
  RESET_USERS_FILTER: "USERS:RESET_FILTER",
  //
  SET_LOADING_FILTER: "USERS:SET_LOADING_FILTER",
  SET_LOADING_USERS: "USERS:SET_LOADING_USERS",
  //
  SET_LANGUAGES_LIST: "USERS:SET_LANGUAGES_LIST",
  SET_INTERESTS_LIST: "USERS:SET_INTERESTS_LIST",
  SET_NATIONALITIES_LIST: "USERS:SET_NATIONALITIES_LIST",
  SET_SEXTYPES_LIST: "USERS:SET_SEXTYPES_LIST",
  //
  SET_USER_INFO: "USERS:SET_USER_INFO",
  SET_LOADING_CURRENT_USER: "USER:SET_LOADING_CURRENT_USER",
  //
  SET_USER_BANNED: "USERS:SET_USER_BANNED",
  SET_REQUEST_PRIVATE_PHOTOS_PENDING:
    "USERS:SET_REQUEST_PRIVATE_PHOTOS_PENDING",
  //
  SET_USER_SYSTEM_BLOCKED: "USERS:SET_USER_SYSTEM_BLOCKED",
  SET_USER_DELETED: "USERS:SET_USER_DELETED",
  SET_USER_NOT_FOUND: "USERS:SET_USER_NOT_FOUND"
};

type rangeType = {
  from: number;
  to: number;
};

export type filterType = {
  age?: rangeType;
  idCountry?: number;
  cities?: Array<number>;
  education?: Array<string>;
  income?: Array<string>;
  height?: rangeType;
  weight?: rangeType;
  hairColor?: Array<string>;
  languages?: Array<number>;
  smoking?: Array<string>;
  alcohol?: Array<string>;
  eyesColor?: Array<string>;
  nationalities?: Array<string>;
  interests?: Array<number>;
  sex?: number;
  children?: null | boolean;
  relationStatus?: Array<number>;
  online?: boolean;
  newest?: boolean;
};

export type userPreviewType = {
  numberOfPhotos: number;
  previewUser: {
    isAnonymousUser: boolean;
    mainPhotoVerifiedStatus?: boolean;
    mainPhoto: {
      photoSmall: string;
      photoNormal: string;
      photoLarge: string;
      photoCropNormal?: string;
      photoCropSmall?: string;
    };
    previewUserInfo: {
      birthday: string;
      city: dataTypeForSelect;
      country: dataTypeForSelect;
      id: string;
      name: string;
    };
    onlineStatus: {
      online: boolean;
      lastTimeActivity:string;
    };
  };
};

type dataTypeForSelect = {
  id: number;
  name: string;
};

export type photoType = {
  photoInfo: {
    id: number;
    name: string;
    dateCreate: string;
    mainPhoto: boolean;
    profileOwnerId: string;
    galleryType: galleryTypes;
    verified?: 0 | 1 | 2
  };
  photoUrl: {
    photoSmall: string;
    photoNormal: string;
    photoLarge: string;
    photoCropSmall?: string;
  };
};

export type userType = {
  id: string;
  name: string;
  sex: genderType;
  birthday: string;
  city: dataTypeForSelect; // TODO add country
  about_me?: string;
  income?: string;
  languages?: dataTypeForSelect | Array<dataTypeForSelect>;
  nationality?: dataTypeForSelect;
  relation?: string;
  children?: boolean;
  interest?: Array<dataTypeForSelect>;
  education?: string;
  badHabits?: {
    smoking: string;
    alcohol: string;
  };
  appearance?: {
    height: number;
    weight: number;
    hair: string;
    eyes: string;
  };
  photos?: Array<photoType>;
  UserMetaInfo: {
    bannedStatus: {
      profileBanUser: false;
      userBanProfile: false;
    };
    privatePhotoAccessStatus: {
      profileBanUser: false;
      userBanProfile: false;
    };
    privatePhotoAccessRequestStatus: {
      profileBanUser: false;
      userBanProfile: false;
    };
  };
};

// Ключи переводов (раньше были русские строки → на любом языке показывалось
// «Негативно/Терпимо»). Отображать через t().
export const userBadHabits = {
  0: "entities.negative",
  1: "entities.tolerant",
  2: "entities.neutral",
  3: "entities.positive",
}

export enum apiUserBadHabits {
  Negative = 0,
  Tolerant = 1,
  Neutral = 2,
  Positive = 3,
}

export enum userEyes {
  Blue = "Голубые",
  Brown = "Карие",
  Gray = "Серые",
  Green = "Зеленые",
}

export enum apiUserEyes {
  Brown = 0,
  Green = 1,
  Blue = 2,
  Gray = 3,
}

export const eyesForDisplay = {
  0: "entities.brown",
  1: "entities.green",
  2: "entities.blue",
  3: "entities.gray",
}

export enum userHairs {
  Blonde = "Блонд",
  Black = "Черный",
  Brown = "Коричневый",
  Red = "Красный",
}

export enum apiUserHairs {
  Blonde = 0,
  Black = 1,
  Brown = 2,
  Red = 3,
}

export const hairsForDisplay = {
  0: {
    [apiUserHairs.Blonde]: "entities.blondeHairMan",
    [apiUserHairs.Black] :"entities.brunetteHairMan",
    [apiUserHairs.Brown] :"entities.brownHairMan",
    [apiUserHairs.Red] :"entities.redHairMan",
  },
  1: {
    [apiUserHairs.Blonde]: "entities.blondeHairWoman",
    [apiUserHairs.Black] :"entities.brunetteHairWoman",
    [apiUserHairs.Brown] :"entities.brownHairWoman",
    [apiUserHairs.Red] :"entities.redHairWoman",
  }
}

export const relationsForDisplay = {
  0: {
    0: "entities.singleMan", 
    1: "entities.relationshipMan",
    2: "", // TODO apple review
    3: "entities.divorcedMan", // TODO apple review
  },
  1: {
    0: "entities.singleWoman",
    1: "entities.relationshipWoman", 
    2: "", // TODO apple review
    3: "entities.divorcedWoman", // TODO apple review
  }
}

export enum apiUserIncomes {
  Low = 0,
  Average = 1,
  High = 2,
  VeryHigh = 3,
}

export const userIncomes = {
  0: "entities.low",
  1: "entities.averge",
  2: "entities.high",
  3: "entities.veryHigh",
}

export const userEducations = {
  0: "entities.secondary",
  1: "entities.gettingHigher",
  2: "entities.higher",
  3: "entities.phD"
}

export enum apiUserEducations {
  Secondary = 0,
  IncompleteHigher = 1,
  Higher = 2,
  PhD = 3
}

export const datingPurposes = {
  "Male": {
    0: "", // TODO apple review Свободные отношения
    1: "entities.longTermRelationship",
    2: "entities.lookingForSponsor",
    3: "entities.justChatting",
    4: "entities.trips"
  },
  "Female": {
    0: "", // TODO apple review Свободные отношения
    1: "entities.longTermRelationship",
    2: "entities.lookingForSponsor",
    3: "entities.justChatting",
    4: "entities.trips"
  },
  "NonBinary": {
    0: "", // TODO apple review Свободные отношения
    1: "entities.longTermRelationship",
    2: "entities.lookingForSponsor",
    3: "entities.justChatting",
    4: "entities.trips"
  }
}

export const occupations = [
  { id: 0, name: "entities.occupationEntrepreneur" },
  { id: 1, name: "entities.occupationExecutive" },
  { id: 2, name: "entities.occupationInvestor" },
  { id: 3, name: "entities.occupationTech" },
  { id: 4, name: "entities.occupationFinance" },
  { id: 5, name: "entities.occupationCreative" },
  { id: 6, name: "entities.occupationStudent" },
  { id: 7, name: "entities.occupationNotWorking" },
  { id: 8, name: "entities.occupationOther" },
];

export enum apiDatingPurposes {
  FreeRelationship = 0,
  LongTermRelationship = 1,
  LookingForSponsor = 2,
  Chatting = 3,
  Travel = 4
}

// Цель знакомства: показываем/редактируем только из списка (1–4). 0 («Свободные
// отношения») скрыт для Apple review, "None"/null — не выбрано. Как в приле:
// параметр без названия не показывается (иначе в профиле пустая строка).
export const normalizeDatingPurpose = (v: any): any => {
  if (v === null || v === undefined || v === "" || v === "None") return undefined;
  const n = Number(v);
  return n >= 1 && n <= 4 ? n : undefined;
};

export enum weightLimits {
  min = 40,
  max = 100
}

export enum heightLimits {
  min = 120,
  max = 240
}

export enum apiSexPeriodicity {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  NotImportant = 3,
}

export const sexPeriodicityForDisplay = {
  0: "Ежедневно",
  1: "Раз в неделю",
  2: "Раз в месяц",
  3: "Не важно",
}

export enum apiSexualOrientation {
  Hetero = 0,
  Bio = 1,
}

export const sexualOrientationForDisplay = {
  0: "Гетеро",
  1: "Би",
}

export enum apiBreastSize {
  First = 0,
  Second = 1,
  Third = 2,
  Fourth = 3,
  FiveAndMore = 4
}

export const breastSizeForDisplay = {
  0: "Первый",
  1: "Второй",
  2: "Третий",
  3: "Четвертый",
  4: "Пятый и больше"
}

export enum userInfoResponseCodes {
  userNotFound = 42,
  userSystemBanned = 40,
  userDeleted = 41
}